/**
 * Guest-realm source for the Chat extension. Chat is host-rendered
 * (ChatSidebar.js + ChatMessageView.js) and talks to the Phoenix backend over
 * the shared socket, bypassing the guest sandbox. This entry script is a no-op
 * kept only to satisfy the extension registration contract.
 */
export const chatEntrySource = `
(function () {
  var sdk = window.apibooSDK;
  sdk.onActivate(function () {});
})();
`;
